import { styled } from '@mui/material/styles';
import { sizes } from 'src/themes/sizes';

export const Background = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.green.tint,
  width: '100%',
  minHeight: '100vh',
  overflowX: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
}));

export const Card = styled('main')(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(18),
  marginBottom: theme.spacing(8),
  backgroundColor: '#FFFFFF',
  width: '100%',
  maxWidth: sizes.box.maxWidth,
  boxShadow: '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)',
  borderRadius: sizes.radius.md,
  padding: `${theme.spacing(7.5)} ${theme.spacing(10)} ${theme.spacing(5)}`,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    minHeight: '100vh',
    maxWidth: '100vw',
    borderRadius: 0,
    padding: `${theme.spacing(12.5)} ${theme.spacing(3.5)} ${theme.spacing(3.75)}`,
  },
}));

export const Title = styled('h1')(({ theme }) => ({
  fontSize: sizes.fontSize.titleMedium,
  fontWeight: 700,
  margin: 0,
  color: theme.palette.green.dark,
}));

export const Description = styled('p')(({ theme }) => ({
  fontSize: sizes.fontSize.body,
  margin: 0,
  color: theme.palette.text.light,
}));

export const Hint = styled('p')(({ theme }) => ({
  fontSize: sizes.fontSize.label,
  margin: 0,
  color: theme.palette.grey['700'],
}));
